export default "__VITE_ASSET__3PsBHWE3__"